import {useParams} from 'react-router-dom'
import {PageLink} from '../../_metronic/layout/core'
import {Navigation} from '../../components/Navigation'
import useMeta from '../../hook/useMeta'
import ScriptDetails from './layouts/ScriptDetails'

const storeFrontScriptManagerDetailsPageBreadcrumbs: PageLink[] = [
  {
    title: 'StoreFronts',
    path: '/storefronts/navigations',
    isActive: false,
  },
  {
    title: 'Script Manager',
    path: '/storefronts/script-manager',
    isActive: false,
  },
]

const StoreFrontScriptManagerDetailsPage = () => {
  const {id, name} = useParams<{id: string; name: string}>()

  useMeta(name ? name : 'Create Script')

  return (
    <Navigation
      baseUrl={`/storefronts/script-manager/${id}/${name}`}
      breadcrumbs={storeFrontScriptManagerDetailsPageBreadcrumbs}
      navigationData={[
        {
          key: 'script-details',
          label: name ? name : 'Create Script',
          component: <ScriptDetails scriptId={id} />,
        },
      ]}
    />
  )
}

export default StoreFrontScriptManagerDetailsPage
